export default function() {
  return new Worker(__webpack_public_path__ + "static/js/worker.5b325987.worker.js");
}
